// All 54 Sovereign African Countries & Automotive Commercial Hubs
export type MarketLaunchStatus = 'live' | 'expanding' | 'coming_soon'

export interface WestAfricanCountry {
  code: string
  name: string
  currency: string
  symbol: string
  dial: string
  flag: string
  region: string
  status: MarketLaunchStatus
  statusLabel: string
  hub?: string
}

export interface AfricanCountry extends WestAfricanCountry {}

export interface WestAfricanCurrency {
  code: string
  symbol: string
  name: string
  country: string
  flag: string
}

export interface AfricanCurrency extends WestAfricanCurrency {}

export const ALL_54_AFRICAN_COUNTRIES: AfricanCountry[] = [
  {
    "code": "DZ",
    "name": "Algeria",
    "currency": "DZD",
    "symbol": "DA",
    "dial": "+213",
    "flag": "\ud83c\udde9\ud83c\uddff",
    "region": "North Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Algiers (Oued Smar & El Harrach)"
  },
  {
    "code": "AO",
    "name": "Angola",
    "currency": "AOA",
    "symbol": "Kz",
    "dial": "+244",
    "flag": "\ud83c\udde6\ud83c\uddf4",
    "region": "Central/Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Luanda (Mercado dos Correios & Palanca)"
  },
  {
    "code": "BJ",
    "name": "Benin",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+229",
    "flag": "\ud83c\udde7\ud83c\uddef",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Cotonou (March\u00e9 Dantokpa & Akpakpa)"
  },
  {
    "code": "BW",
    "name": "Botswana",
    "currency": "BWP",
    "symbol": "P",
    "dial": "+267",
    "flag": "\ud83c\udde7\ud83c\uddfc",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Gaborone (Broadhurst Industrial & Mogoditshane)"
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+226",
    "flag": "\ud83c\udde7\ud83c\uddeb",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Ouagadougou (Sankariar\u00e9 Market)"
  },
  {
    "code": "BI",
    "name": "Burundi",
    "currency": "BIF",
    "symbol": "FBu",
    "dial": "+257",
    "flag": "\ud83c\udde7\ud83c\uddee",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Bujumbura (Quartier Asiatique)"
  },
  {
    "code": "CV",
    "name": "Cabo Verde",
    "currency": "CVE",
    "symbol": "Esc",
    "dial": "+238",
    "flag": "\ud83c\udde8\ud83c\uddfb",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Praia & Mindelo Port Corridors"
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+237",
    "flag": "\ud83c\udde8\ud83c\uddf2",
    "region": "Central/West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Douala (Ndogbong & Akwa) / Yaound\u00e9 (Mvog-Mbi)"
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+236",
    "flag": "\ud83c\udde8\ud83c\uddeb",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Bangui (March\u00e9 Central & KM 5)"
  },
  {
    "code": "TD",
    "name": "Chad",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+235",
    "flag": "\ud83c\uddf9\ud83c\udde9",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "N'Djamena (March\u00e9 de Demb\u00e9)"
  },
  {
    "code": "KM",
    "name": "Comoros",
    "currency": "KMF",
    "symbol": "CF",
    "dial": "+269",
    "flag": "\ud83c\uddf0\ud83c\uddf2",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Moroni (Volovolo Market)"
  },
  {
    "code": "CG",
    "name": "Congo (Republic)",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+242",
    "flag": "\ud83c\udde8\ud83c\uddec",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Brazzaville (March\u00e9 Total) & Pointe-Noire"
  },
  {
    "code": "CD",
    "name": "DR Congo",
    "currency": "CDF",
    "symbol": "FC",
    "dial": "+243",
    "flag": "\ud83c\udde8\ud83c\udde9",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Kinshasa (Barumbu & Ave du Commerce) / Lubumbashi"
  },
  {
    "code": "CI",
    "name": "C\u00f4te d'Ivoire",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+225",
    "flag": "\ud83c\udde8\ud83c\uddee",
    "region": "West Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Abidjan (March\u00e9 Adjam\u00e9 & Marcory)"
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "currency": "DJF",
    "symbol": "Fdj",
    "dial": "+253",
    "flag": "\ud83c\udde9\ud83c\uddef",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Djibouti City (Quartier 4 Free Zone)"
  },
  {
    "code": "EG",
    "name": "Egypt",
    "currency": "EGP",
    "symbol": "E\u00a3",
    "dial": "+20",
    "flag": "\ud83c\uddea\ud83c\uddec",
    "region": "North Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Cairo (Tewfikia & El-Dars) / Alexandria"
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+240",
    "flag": "\ud83c\uddec\ud83c\uddf6",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Malabo (Mercado Central) & Bata"
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "currency": "ERN",
    "symbol": "Nfk",
    "dial": "+291",
    "flag": "\ud83c\uddea\ud83c\uddf7",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Asmara (Edaga Hamus Area)"
  },
  {
    "code": "SZ",
    "name": "Eswatini",
    "currency": "SZL",
    "symbol": "E",
    "dial": "+268",
    "flag": "\ud83c\uddf8\ud83c\uddff",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Manzini (Matsapha Industrial Area) & Mbabane"
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "currency": "ETB",
    "symbol": "Br",
    "dial": "+251",
    "flag": "\ud83c\uddea\ud83c\uddf9",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Addis Ababa (Somale Tera, Merkato)"
  },
  {
    "code": "GA",
    "name": "Gabon",
    "currency": "XAF",
    "symbol": "FCFA",
    "dial": "+241",
    "flag": "\ud83c\uddec\ud83c\udde6",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Libreville (Gare Routi\u00e8re & Oloumi Industrial)"
  },
  {
    "code": "GM",
    "name": "The Gambia",
    "currency": "GMD",
    "symbol": "D",
    "dial": "+220",
    "flag": "\ud83c\uddec\ud83c\uddf2",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Banjul & Serekunda (Kanifing Industrial)"
  },
  {
    "code": "GH",
    "name": "Ghana",
    "currency": "GHS",
    "symbol": "GH\u20b5",
    "dial": "+233",
    "flag": "\ud83c\uddec\ud83c\udded",
    "region": "West Africa",
    "status": "live",
    "statusLabel": "Live Marketplace",
    "hub": "Accra (Abossey Okai) / Kumasi (Suame Magazine)"
  },
  {
    "code": "GN",
    "name": "Guinea",
    "currency": "GNF",
    "symbol": "FG",
    "dial": "+224",
    "flag": "\ud83c\uddec\ud83c\uddf3",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Conakry (March\u00e9 Madina)"
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+245",
    "flag": "\ud83c\uddec\ud83c\uddfc",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Bissau (March\u00e9 de Bandim)"
  },
  {
    "code": "KE",
    "name": "Kenya",
    "currency": "KES",
    "symbol": "KSh",
    "dial": "+254",
    "flag": "\ud83c\uddf0\ud83c\uddea",
    "region": "East Africa",
    "status": "live",
    "statusLabel": "Live Marketplace",
    "hub": "Nairobi (Kirinyaga Road & Industrial Area) / Mombasa"
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "currency": "LSL",
    "symbol": "L",
    "dial": "+266",
    "flag": "\ud83c\uddf1\ud83c\uddf8",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Maseru (Industrial Area)"
  },
  {
    "code": "LR",
    "name": "Liberia",
    "currency": "LRD",
    "symbol": "L$",
    "dial": "+231",
    "flag": "\ud83c\uddf1\ud83c\uddf7",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Monrovia (Via Town & Bushrod Island)"
  },
  {
    "code": "LY",
    "name": "Libya",
    "currency": "LYD",
    "symbol": "LD",
    "dial": "+218",
    "flag": "\ud83c\uddf1\ud83c\uddfe",
    "region": "North Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Tripoli (Suq al-Jum'aa) & Benghazi"
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "currency": "MGA",
    "symbol": "Ar",
    "dial": "+261",
    "flag": "\ud83c\uddf2\ud83c\uddec",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Antananarivo (Isotry & Tsaralalana)"
  },
  {
    "code": "MW",
    "name": "Malawi",
    "currency": "MWK",
    "symbol": "MK",
    "dial": "+265",
    "flag": "\ud83c\uddf2\ud83c\uddfc",
    "region": "East/Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Blantyre (Limbe) & Lilongwe"
  },
  {
    "code": "ML",
    "name": "Mali",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+223",
    "flag": "\ud83c\uddf2\ud83c\uddf1",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Bamako (Dabanani Market & Niar\u00e9la)"
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "currency": "MRU",
    "symbol": "UM",
    "dial": "+222",
    "flag": "\ud83c\uddf2\ud83c\uddf7",
    "region": "West/North Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Nouakchott (March\u00e9 Sixi\u00e8me)"
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "currency": "MUR",
    "symbol": "Rs",
    "dial": "+230",
    "flag": "\ud83c\uddf2\ud83c\uddfa",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Port Louis (Plaine Verte & Roche Bois)"
  },
  {
    "code": "MA",
    "name": "Morocco",
    "currency": "MAD",
    "symbol": "DH",
    "dial": "+212",
    "flag": "\ud83c\uddf2\ud83c\udde6",
    "region": "North Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Casablanca (Derb Omar & Lalla Yacout) / Tangier"
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "currency": "MZN",
    "symbol": "MT",
    "dial": "+258",
    "flag": "\ud83c\uddf2\ud83c\uddff",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Maputo (Avenida Guerra Popular) & Beira"
  },
  {
    "code": "NA",
    "name": "Namibia",
    "currency": "NAD",
    "symbol": "N$",
    "dial": "+264",
    "flag": "\ud83c\uddf3\ud83c\udde6",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Windhoek (Northern Industrial Area)"
  },
  {
    "code": "NE",
    "name": "Niger",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+227",
    "flag": "\ud83c\uddf3\ud83c\uddea",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Niamey (Grand March\u00e9 & Katako Market)"
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "currency": "NGN",
    "symbol": "\u20a6",
    "dial": "+234",
    "flag": "\ud83c\uddf3\ud83c\uddec",
    "region": "West Africa",
    "status": "live",
    "statusLabel": "Live Marketplace",
    "hub": "Lagos (Ladipo & ASPAMDA) / Nnewi / Kano / Abuja"
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "currency": "RWF",
    "symbol": "FRw",
    "dial": "+250",
    "flag": "\ud83c\uddf7\ud83c\uddfc",
    "region": "East Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Kigali (Gakinjiro in Nyarugenge & Muhima)"
  },
  {
    "code": "ST",
    "name": "S\u00e3o Tom\u00e9 and Pr\u00edncipe",
    "currency": "STN",
    "symbol": "Db",
    "dial": "+239",
    "flag": "\ud83c\uddf8\ud83c\uddf9",
    "region": "Central Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "S\u00e3o Tom\u00e9 (Mercado Municipal)"
  },
  {
    "code": "SN",
    "name": "Senegal",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+221",
    "flag": "\ud83c\uddf8\ud83c\uddf3",
    "region": "West Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Dakar (M\u00e9dina, Plateau & March\u00e9 Castors)"
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "currency": "SCR",
    "symbol": "SR",
    "dial": "+248",
    "flag": "\ud83c\uddf8\ud83c\udde8",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Victoria (Mah\u00e9 Island)"
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "currency": "SLE",
    "symbol": "Le",
    "dial": "+232",
    "flag": "\ud83c\uddf8\ud83c\uddf1",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Freetown (Rawdon Street & Cline Town)"
  },
  {
    "code": "SO",
    "name": "Somalia",
    "currency": "SOS",
    "symbol": "Sh",
    "dial": "+252",
    "flag": "\ud83c\uddf8\ud83c\uddf4",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Mogadishu (Bakara Market) & Hargeisa"
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "currency": "ZAR",
    "symbol": "R",
    "dial": "+27",
    "flag": "\ud83c\uddff\ud83c\udde6",
    "region": "Southern Africa",
    "status": "live",
    "statusLabel": "Live Marketplace",
    "hub": "Johannesburg (Selby, Fordsburg, Booysens) / Durban / Cape Town"
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "currency": "SSP",
    "symbol": "SS\u00a3",
    "dial": "+211",
    "flag": "\ud83c\uddf8\ud83c\uddf8",
    "region": "East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Juba (Konyo Konyo Market)"
  },
  {
    "code": "SD",
    "name": "Sudan",
    "currency": "SDG",
    "symbol": "SDG",
    "dial": "+249",
    "flag": "\ud83c\uddf8\ud83c\udde9",
    "region": "North/East Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Khartoum (Sajana Market) & Port Sudan"
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "currency": "TZS",
    "symbol": "TSh",
    "dial": "+255",
    "flag": "\ud83c\uddf9\ud83c\uddff",
    "region": "East Africa",
    "status": "live",
    "statusLabel": "Live Marketplace",
    "hub": "Dar es Salaam (Kariakoo & Gerezani)"
  },
  {
    "code": "TG",
    "name": "Togo",
    "currency": "XOF",
    "symbol": "CFA",
    "dial": "+228",
    "flag": "\ud83c\uddf9\ud83c\uddec",
    "region": "West Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Lom\u00e9 (Grand March\u00e9 & Akod\u00e9ss\u00e9wa Zone)"
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "currency": "TND",
    "symbol": "DT",
    "dial": "+216",
    "flag": "\ud83c\uddf9\ud83c\uddf3",
    "region": "North Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Tunis (El Kabaria & Djebel Djelloud)"
  },
  {
    "code": "UG",
    "name": "Uganda",
    "currency": "UGX",
    "symbol": "USh",
    "dial": "+256",
    "flag": "\ud83c\uddfa\ud83c\uddec",
    "region": "East Africa",
    "status": "expanding",
    "statusLabel": "Expanding Hub",
    "hub": "Kampala (Katwe, Kisenyi & Nakasero)"
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "currency": "ZMW",
    "symbol": "ZK",
    "dial": "+260",
    "flag": "\ud83c\uddff\ud83c\uddf2",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Lusaka (Kamwala & Lumumba Road) / Kitwe"
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "currency": "ZWG",
    "symbol": "ZiG",
    "dial": "+263",
    "flag": "\ud83c\uddff\ud83c\uddfc",
    "region": "Southern Africa",
    "status": "coming_soon",
    "statusLabel": "Coming Soon",
    "hub": "Harare (Graniteside, Mbare & Kaguvi St) / Bulawayo"
  }
];

export const WEST_AFRICAN_COUNTRIES: WestAfricanCountry[] = ALL_54_AFRICAN_COUNTRIES;

export const ALL_SUPPORTED_CURRENCIES: AfricanCurrency[] = [
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', country: 'NG', flag: '🇳🇬' },
  { code: 'GHS', symbol: 'GH₵', name: 'Ghanaian Cedi', country: 'GH', flag: '🇬🇭' },
  { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', country: 'KE', flag: '🇰🇪' },
  { code: 'ZAR', symbol: 'R', name: 'South African Rand', country: 'ZA', flag: '🇿🇦' },
  { code: 'TZS', symbol: 'TSh', name: 'Tanzanian Shilling', country: 'TZ', flag: '🇹🇿' },
  { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound', country: 'EG', flag: '🇪🇬' },
  { code: 'MAD', symbol: 'DH', name: 'Moroccan Dirham', country: 'MA', flag: '🇲🇦' },
  { code: 'DZD', symbol: 'DA', name: 'Algerian Dinar', country: 'DZ', flag: '🇩🇿' },
  { code: 'AOA', symbol: 'Kz', name: 'Angolan Kwanza', country: 'AO', flag: '🇦🇴' },
  { code: 'ETB', symbol: 'Br', name: 'Ethiopian Birr', country: 'ET', flag: '🇪🇹' },
  { code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling', country: 'UG', flag: '🇺🇬' },
  { code: 'RWF', symbol: 'FRw', name: 'Rwandan Franc', country: 'RW', flag: '🇷🇼' },
  { code: 'XOF', symbol: 'CFA', name: 'West African CFA Franc', country: 'CI', flag: '🇨🇮' },
  { code: 'XAF', symbol: 'FCFA', name: 'Central African CFA Franc', country: 'CM', flag: '🇨🇲' },
  { code: 'GNF', symbol: 'FG', name: 'Guinean Franc', country: 'GN', flag: '🇬🇳' },
  { code: 'SLE', symbol: 'Le', name: 'Sierra Leonean Leone', country: 'SL', flag: '🇸🇱' },
  { code: 'LRD', symbol: 'L$', name: 'Liberian Dollar', country: 'LR', flag: '🇱🇷' },
  { code: 'GMD', symbol: 'D', name: 'Gambian Dalasi', country: 'GM', flag: '🇬🇲' },
  { code: 'CVE', symbol: 'Esc', name: 'Cape Verdean Escudo', country: 'CV', flag: '🇨🇻' },
  { code: 'BWP', symbol: 'P', name: 'Botswana Pula', country: 'BW', flag: '🇧🇼' },
  { code: 'ZMW', symbol: 'ZK', name: 'Zambian Kwacha', country: 'ZM', flag: '🇿🇲' },
  { code: 'ZWG', symbol: 'ZiG', name: 'Zimbabwe Gold', country: 'ZW', flag: '🇿🇼' },
  { code: 'CDF', symbol: 'FC', name: 'Congolese Franc', country: 'CD', flag: '🇨🇩' },
  { code: 'MUR', symbol: 'Rs', name: 'Mauritian Rupee', country: 'MU', flag: '🇲🇺' },
  { code: 'TND', symbol: 'DT', name: 'Tunisian Dinar', country: 'TN', flag: '🇹🇳' },
];

export const WEST_AFRICAN_CURRENCIES: WestAfricanCurrency[] = ALL_SUPPORTED_CURRENCIES;

export const PHONE_DIAL_CODES = ALL_54_AFRICAN_COUNTRIES.map((c) => ({
  country: c.name,
  code: c.code,
  dial: c.dial,
  flag: c.flag,
}));

export function getCountryByCode(code?: string): AfricanCountry {
  if (!code) return ALL_54_AFRICAN_COUNTRIES.find(c => c.code === 'NG') || ALL_54_AFRICAN_COUNTRIES[0];
  const upper = String(code).toUpperCase().trim();
  return ALL_54_AFRICAN_COUNTRIES.find((c) => c.code === upper) || ALL_54_AFRICAN_COUNTRIES[0];
}

export function getCurrencyByCode(code?: string): AfricanCurrency {
  if (!code) return ALL_SUPPORTED_CURRENCIES[0];
  const upper = String(code).toUpperCase().trim();
  
  // 1. Check direct currency code (e.g., GHS, NGN, KES)
  const byCurr = ALL_SUPPORTED_CURRENCIES.find((c) => c.code === upper);
  if (byCurr) return byCurr;

  // 2. Check direct country code (e.g., GH, NG, KE)
  const byCountry = ALL_SUPPORTED_CURRENCIES.find((c) => c.country === upper);
  if (byCountry) return byCountry;

  // 3. Fallback through getCountryByCode
  const countryObj = ALL_54_AFRICAN_COUNTRIES.find((c) => c.code === upper || c.name.toUpperCase() === upper);
  if (countryObj && countryObj.currency) {
    const fromCountry = ALL_SUPPORTED_CURRENCIES.find((c) => c.code === countryObj.currency);
    if (fromCountry) return fromCountry;
  }

  // 4. Default to NGN if completely unknown
  return ALL_SUPPORTED_CURRENCIES[0];
}

/**
 * Formats a numeric price into authentic local currency with strict African currency symbols.
 * Never defaults to '$' unless USD was explicitly requested.
 */
export function formatLocalPrice(amount: number | string | undefined | null, countryOrCurrency?: string): string {
  const val = Number(amount || 0);
  const cur = getCurrencyByCode(countryOrCurrency);
  const sym = cur.symbol || (cur.code === 'GHS' ? 'GH₵' : cur.code === 'XOF' ? 'CFA' : '₦');
  return `${sym} ${val.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function getDialCodeForCountry(countryCode?: string): string {
  if (!countryCode) return '+234';
  const c = getCountryByCode(countryCode);
  return c.dial || '+234';
}

